
import { Navigate } from "react-router-dom";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminUsers } from "@/pages/admin/AdminUsers";
import { AdminMeals } from "@/pages/admin/AdminMeals";
import { AdminDisputes } from "@/pages/admin/AdminDisputes";
import { TransactionList } from "@/pages/admin/TransactionList";
import CookVerifications from "@/pages/admin/CookVerifications";
import PlatformSettings from "@/pages/admin/PlatformSettings";
import AdminReporting from "@/pages/admin/AdminReporting";
import EmailTemplates from "@/pages/admin/EmailTemplates";
import PayoutsAdmin from "@/pages/admin/PayoutsAdmin";
import { RouteProps } from "@/types/routes";
import { RouteObject } from "react-router-dom";

export const adminRoutes = ({ session }: RouteProps): RouteObject[] => [
  {
    path: "/admin",
    element: session ? <Navigate to="/admin/dashboard" /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/dashboard",
    element: session ? <AdminDashboard /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/users",
    element: session ? <AdminUsers /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/meals",
    element: session ? <AdminMeals /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/disputes",
    element: session ? <AdminDisputes /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/transactions",
    element: session ? <TransactionList /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/verifications",
    element: session ? <CookVerifications /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/settings",
    element: session ? <PlatformSettings /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/reporting",
    element: session ? <AdminReporting /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/email-templates",
    element: session ? <EmailTemplates /> : <Navigate to="/auth" />
  },
  {
    path: "/admin/payouts",
    element: session ? <PayoutsAdmin /> : <Navigate to="/auth" />
  }
];
